import { createSelector } from "@reduxjs/toolkit";
import { selectCurrentOpenIssueModal } from "../../../../issueSelectors";

export const selectFormulaCounterGroupIssuesBaseArgsInModal = createSelector([selectCurrentOpenIssueModal], (modal) => {
  if (modal?.projectId == null || modal.boardId == null) return null;

  return {
    projectId: modal.projectId,
    issueBoardId: modal.boardId,
  };
});
